<section id="proxy-voting" class="container proxy-voting">
    <h2 class="proxy-voting__title rps-heading-two" id="proxy-voting_header">Proxy voting</h2>
    <div class="proxy-voting__content" [innerHTML]="proxyVoting"></div>
</section>
